var dcItemBindings = { item: '=', row: '<', comp: '<', filter: '=' };
var MultiController = (function () {
    function MultiController($scope, socket, settings, topic, Dialog, $state, $timeout, env, $http, notify, moment, _) {
        var _this = this;
        this.$scope = $scope;
        this.socket = socket;
        this.settings = settings;
        this.topic = topic;
        this.Dialog = Dialog;
        this.$state = $state;
        this.$timeout = $timeout;
        this.env = env;
        this.$http = $http;
        this.notify = notify;
        this.moment = moment;
        this._ = _;
        this.checksData = _.get(this, 'topic.checksData.result');
        this.tableStyle = { padding: '0px', border: 'none' };
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        if (!this.topic.topic.version || this.topic.topic.version <= this.OPP_VERSION_4) {
            this.dupPath = 'DUPMYSA';
        }
        else {
            this.dupPath = 'DUP';
        }
        this.expand = false;
        // receive broadcasts in case some1 wants to expand or collapse sections
        this.socket.forward('expand.all', this.$scope);
        this.$scope.$on("expand.all. " + this.comp, function (event, data) {
            _this.toggle(data);
        });
        this.filterObject = {};
        this.searchCriteria = false;
        this.showSecondary = false;
        if (this.comp === 'dc_v5') {
            this.excelComp = this.item.isEi ? 'dc_v5_ei' : 'dc_v5_ssa';
        }
        else {
            this.excelComp = this.comp;
        }
    }
    /**
     * If dupCheckResult contain duplicates return 0 otherwise
     * length of data
     * @returns {number}
     * @memberof MultiController
     */
    MultiController.prototype.dupCheckResultLength = function () {
        return _.get(this.dupCheckResult[0], 'duplicates')
            ? 0
            : this.dupCheckResult.length;
    };
    MultiController.prototype.toggleCriteria = function () {
        this.searchCriteria = !this.searchCriteria;
    };
    MultiController.prototype.clearFilter = function (filtName) {
        this.filterObject.filters[filtName].picked = [];
        this.blurFilterPick();
    };
    MultiController.prototype.searchParams = function () {
        var searchPath = this.item.searchParams;
        return [
            { name: 'Key Word', value: searchPath.keyWord },
            { name: 'Country selected', value: searchPath.cmrArray },
            { name: 'Alt Brand Family', value: searchPath.altBrandFamily },
        ];
    };
    /**
     * Toggles the table row, when it contains a secondary row as a table
     * @param rowObj    row to be toggled
     * @returns void
     */
    MultiController.prototype.toggleRow = function (rowObj) {
        rowObj.visible = angular.isDefined(rowObj.visible) && rowObj.visible ? false : true;
    };
    MultiController.prototype.changedValue = function () {
        this.filterObject.calculated = false;
    };
    MultiController.prototype.makeFilterOptions = function () {
        var _this = this;
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            //browse through every item in table
            this.filterObject.calculated = true;
            angular.forEach(this.item_array, function (tableLine) {
                //if the item is unique, put it into the representing unique value
                for (var prop in _this.filterObject.filters) {
                    if (_this.filterObject.filters[prop].type === 's') {
                        if (_this.filterObject.filters[prop].unique.indexOf(tableLine[prop]) < 0) {
                            _this.filterObject.filters[prop].unique.push(tableLine[prop]);
                        }
                    }
                }
            });
        }
    };
    /**
     * Opens the dropdown with the filters. By changing this, we'll change the limitTo of the filter ng-repeat. This is done for
     * performance increase(So DOM doenst have to have in special cases 4k+ checkboxes)
     * @param id        id of the filter
     * @param size      size of the filter
     * @returns void
     */
    MultiController.prototype.openDrop = function (id, size) {
        this.countDrop[id] = size;
    };
    /**
     * Closes dropdown and sets the limitTo on the filter to 0
     * @param id        id of the filter
     * @returns void
     */
    MultiController.prototype.closeDrop = function (id) {
        this.countDrop[id] = 0;
        this.blurFilterPick();
    };
    /**
     * Export report into Excel file
     * @returns void
     */
    MultiController.prototype.excelExport = function () {
        console.info('Sending export Excel request');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    comp: this.excelComp,
                    dupCheckResult: this.dupCheckResult,
                    id: this.topic.getId(this.topic.topic._id),
                    timestamp: this.item.finalTimestamp
                },
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token
            }
        });
    };
    MultiController.prototype.showCmrArrayList = function () {
        var toggleDecision = !this.expand;
        this.toggle(toggleDecision);
        var items = {
            dialogName: this.item.searchParams.cmrArray
        };
        this.Dialog.updateValidForm(event, items, 'cmrArray-dialog.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
    };
    MultiController.prototype.convertToUnix = function (time) {
        if (this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5) {
            return this.moment.utc(time).format('LLL');
        }
        else {
            return this.moment.unix(time).format('LLL');
        }
    };
    // Return full name of the country (example "US" => "USA")
    MultiController.prototype.getCountryFullName = function (country) {
        for (var _i = 0, _a = this.topic.settings.country_list; _i < _a.length; _i++) {
            var e = _a[_i];
            if (e.short === country) {
                return e.cc_text;
            }
        }
    };
    MultiController.prototype.fillArrayBasedOnComponent = function () {
        switch (this.comp) {
            case 'dc_mysa':
            case 'dc_mysa_v4': {
                this.dupCheckResult = this.extractMySADupCheckResults();
                if (this.dupCheckResult && this.dupCheckResult.length > 0) {
                    this.dupCheckResult = this.extendDupCheckResult();
                }
                break;
            }
            case 'dc_v5': {
                this.dupCheckResult = this.extractMySADupCheckResultsV5();
                break;
            }
            case 'dc_sc': {
                this.dupCheckResult = this.extractSCDupCheckResults();
                break;
            }
        }
        if (this.dupCheckResult && this.dupCheckResult.length > 0) {
            this.rowOrder = this.getColumnObj();
            this.convertDatesToUtc();
        }
    };
    MultiController.prototype.extractMySADupCheckResults = function () {
        var dupCheck = _.get(this.checksData, this.dupPath + ".data.mySADuplicateCheckResult.data");
        if (dupCheck === undefined) {
            dupCheck = _.get(this.checksData, this.dupPath + ".data.mySADuplicateCheckResult");
            if (Array.isArray(dupCheck)) {
                dupCheck = this.collectDuplicates(dupCheck);
            }
        }
        if (dupCheck === undefined) {
            dupCheck = [];
        }
        return dupCheck;
    };
    MultiController.prototype.extractMySADupCheckResultsV5 = function () {
        var dupCheck = this.item.mySADuplicateCheckResult;
        var inboundIncentiveDetail = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail');
        var inboundDealRegs = inboundIncentiveDetail.dealRegs;
        var result = [];
        if (Array.isArray(dupCheck)) {
            // order of properties defines order of columns in the table
            var _loop_1 = function(check) {
                var inboundDealReg = inboundDealRegs.find(function (item) { return item.dealRegGroupId === check.dealRegGroupId; });
                for (var _i = 0, _a = check.duplicates; _i < _a.length; _i++) {
                    var duplicate = _a[_i];
                    var row = {
                        opp: duplicate.opp,
                        bpName: duplicate.bpName,
                        sviSubmitDate: duplicate.sviSubmitDate,
                        sviExpDate: duplicate.sviExpDate,
                        country: duplicate.country,
                        sviOverallStatus: duplicate.sviOverallStatus,
                        accountName: duplicate.accountName,
                        dcid: duplicate.dcid,
                        dbg: duplicate.dbg,
                        drpgId: duplicate.drpgId,
                        drpgName: inboundDealReg.dealRegGroupDescription
                    };
                    if (this_1.item.isEi) {
                        if (duplicate.eiDupReason) {
                            row.eiDup = duplicate.eiDup;
                            row.eiDupReason = duplicate.eiDupReason;
                            result.push(row);
                        }
                    }
                    else {
                        if (duplicate.ssaDupReason) {
                            row.ssaDup = duplicate.ssaDup;
                            row.ssaDupReason = duplicate.ssaDupReason;
                            result.push(row);
                        }
                    }
                }
            };
            var this_1 = this;
            for (var _b = 0, dupCheck_1 = dupCheck; _b < dupCheck_1.length; _b++) {
                var check = dupCheck_1[_b];
                _loop_1(check);
            }
        }
        return result;
    };
    MultiController.prototype.extractSCDupCheckResults = function () {
        var dupCheck = _.get(this.checksData, 'DUPSC.data.scDuplicateCheckResult.data');
        if (dupCheck === undefined) {
            dupCheck = _.get(dupCheck, 'DUPSC.data.scDuplicateCheckResult');
            if (Array.isArray(dupCheck)) {
                dupCheck = this.collectDuplicates(dupCheck);
            }
        }
        return dupCheck;
    };
    MultiController.prototype.extendDupCheckResult = function () {
        var _this = this;
        var dupCheckResultCopy = this.dupCheckResult;
        var duplicateRootObject;
        var getDupeReason = function (brandFamily) {
            var mySADuplicateCheckResult = _.get(_this.checksData, _this.dupPath + ".data.mySADuplicateCheckResult.data")
                || _.get(_this.checksData, _this.dupPath + ".data.mySADuplicateCheckResult");
            var duplicate = mySADuplicateCheckResult
                .filter(function (e) { return e.solutionId === brandFamily; });
            return duplicate.length > 0 ? duplicate[0].reason : '';
        };
        var getDrpgName = function (duplicate) {
            var mySADuplicateCheckResult = _.get(_this.checksData, _this.dupPath + ".data.mySADuplicateCheckResult.data")
                || _.get(_this.checksData, _this.dupPath + ".data.mySADuplicateCheckResult");
            var solutions = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.solutions');
            for (var _i = 0, mySADuplicateCheckResult_1 = mySADuplicateCheckResult; _i < mySADuplicateCheckResult_1.length; _i++) {
                var dupResult = mySADuplicateCheckResult_1[_i];
                for (var _a = 0, _b = dupResult.duplicates; _a < _b.length; _a++) {
                    var e = _b[_a];
                    if (e === duplicate) {
                        duplicateRootObject = Object.assign({}, dupResult);
                        break;
                    }
                }
            }
            var solution = solutions.filter(function (solutionElem) {
                return (solutionElem.solutionId === duplicateRootObject.solutionId && solutionElem.level2Label === duplicateRootObject.level2Label);
            });
            return solution.length > 0 ? solution[0].name : '';
        };
        dupCheckResultCopy.forEach(function (duplicate) {
            delete duplicate.saleStage;
            delete duplicate.brand;
            delete duplicate.bpceid;
            if (!duplicate.dcid) {
                duplicate.dcid = 'N/A';
            }
            if (!duplicate.dbg) {
                duplicate.dbg = 'N/A';
            }
            // Object.assign(duplicate, { dcid: getDomesticValue('Domestic Client ID') });
            // Object.assign(duplicate, { dbg: getDomesticValue('Domestic Buying Group') });
            // Will take common DRPG duplicate reason if it doesn't exist for dup item
            Object.assign(duplicate, { dupeReason: _.get(duplicate, 'reason', getDupeReason(duplicate.brandFamily)) });
            Object.assign(duplicate, { drpgName: getDrpgName(duplicate) });
            delete duplicate.reason;
        });
        return dupCheckResultCopy;
    };
    MultiController.prototype.getColumnObj = function () {
        var arrayOfOrders = [];
        // tslint:disable-next-line: forin
        for (var prop in this.dupCheckResult[0]) {
            this.columnObj = this.settings.columnNames[this.comp][prop]
                ? this.settings.columnNames[this.comp][prop]
                : null;
            if (this.columnObj !== null) {
                this.columnObj.v = prop;
            }
            if (this.columnObj !== null && this.columnObj.h !== '$$hashKey') {
                arrayOfOrders.push(this.columnObj);
            }
        }
        return arrayOfOrders;
    };
    MultiController.prototype.convertDatesToUtc = function () {
        var _this = this;
        this.dupCheckResult.forEach(function (result) {
            if (!Number.isNaN(Number(result.decisionDate))) {
                result.decisionDate = _this.moment.utc(Number(result.decisionDate)).format('LLL');
            }
            if (!Number.isNaN(Number(result.sviExpDate))) {
                result.sviExpDate = _this.moment.utc(Number(result.sviExpDate)).format('LLL');
            }
            if (!Number.isNaN(Number(result.sviSubmitDate))) {
                result.sviSubmitDate = _this.moment.utc(Number(result.sviSubmitDate)).format('LLL');
            }
        });
    };
    MultiController.prototype.collectDuplicates = function (dupCheckResult) {
        var duplicatesArr = [];
        dupCheckResult.forEach(function (dupResult) {
            dupResult.duplicates.forEach(function (duplicate) {
                duplicatesArr.push(duplicate);
            });
        });
        return duplicatesArr;
    };
    /**
     * Expands or collapses sections
     * @param value    boolean to decide if expand or collapse
     * @returns void
     */
    MultiController.prototype.toggle = function (value) {
        this.expand = angular.isUndefined(value) ? !this.expand : value;
    };
    /**
     * Based on the filters selected, only those lines in table are picked, that fullfill the picked filter values
     * @returns void
     */
    MultiController.prototype.blurFilterPick = function () {
        var _this = this;
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            var tempArray_1 = [];
            var filterOK_1 = true;
            angular.forEach(this.item, function (tableLine) {
                filterOK_1 = true;
                var _loop_2 = function(prop) {
                    if (_this.filterObject.filters[prop].type === 's' && filterOK_1) {
                        if (_this.filterObject.filters[prop].picked.length > 0) {
                            filterOK_1 = false;
                            angular.forEach(_this.filterObject.filters[prop].picked, function (picked) {
                                if (picked === tableLine[prop]) {
                                    filterOK_1 = true;
                                }
                            });
                        }
                    }
                };
                for (var prop in _this.filterObject.filters) {
                    _loop_2(prop);
                }
                if (filterOK_1) {
                    tempArray_1.push(tableLine);
                }
            });
            this.item_array = angular.copy(tempArray_1);
        }
    };
    MultiController.prototype.$onInit = function () {
        this.fillArrayBasedOnComponent();
    };
    MultiController.$inject = ['$scope', 'socket', 'settings', 'topic', 'Dialog', '$state', '$timeout', 'env', '$http', 'notify', 'moment', '_'];
    return MultiController;
}());
var MultiComponent = (function () {
    function MultiComponent() {
        this.bindings = dcItemBindings;
        this.templateUrl = 'detail-table-multi-duplcheck-4x4.html';
        this.controller = MultiController;
    }
    return MultiComponent;
}());
angular
    .module('application')
    .component('multiTableDuplcheck4x4', new MultiComponent());

//# sourceMappingURL=detail.table.multi.duplcheck4x4.component.js.map
